module.exports = __webpack_public_path__ + "media/src/images/icons/calendar/yellow-454d4ce773b673a013e43c68dfd8fefa.svg";